import styled from 'styled-components';

export const Divider = styled.p<{ vertical?: boolean }>`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #767676;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: -0.02em;
  margin: 19px 0 16px;
  flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};

  :before,
  :after {
    display: block;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    ${(props) => (props.vertical ? 'width' : 'height')}: 1px;
    background-color: #c2c3c6;
    content: '';
  }

  :before {
    margin: ${(props) => (props.vertical ? '0px 0 8px 0' : '0px 16px 0 0')};
  }

  :after {
    margin: ${(props) => (props.vertical ? '8px 0 0 0' : '0px 0 0 16px')};
  }
`;
